<script>
  import{ fade, fly } from 'svelte/transition'
  import { createEventDispatcher } from 'svelte'
  import { Confirm } from 'svelte-confirm'
  const dispatch = createEventDispatcher();
  export let step = false, detail = false, status = false

  function close() {
    dispatch('close')
  }

  function back() {
    dispatch('back')
  }

  function deleteSub() {
    dispatch('delete')
  }
</script>

<div transition:fade class="overlay" on:click />
<div transition:fly={{ y: 20 }} class="cover">
  {#if step > 1}
  <button on:click={back} class="back">
    <span class="sr-only">Go back one step</span>
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
  </button>
  {/if}
  {#if detail && status != 'approved' && status != 'posted'}
  <Confirm confirmTitle="Delete" cancelTitle="Cancel" let:confirm="{confirmThis}">
    <button on:click={() => confirmThis(deleteSub)} class="close warning" title="Delete this submission">
      <span class="sr-only">Delete this submission</span>
      <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
    </button>
    <span slot="title">
      Delete this submission?
    </span>
    <span slot="description">
      You won't be able to undo this!
    </span>
  </Confirm>
  {:else}
  
  <button on:click={close} class="close">
    <span class="sr-only">Close new submission window</span>
    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
  </button>
  {/if}
  <slot />
</div>

<style>
  .overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%; 
		height: 100%;
		background-color: #000;
		opacity: .4;
		z-index: 9
	}
	.cover {
		z-index: 10;
    position: absolute;
    width: 420px;
    max-width: calc(100% - 1rem);
    padding: 1rem;
    box-sizing: border-box;
    margin: 0 auto;
    top: 2rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    z-index: 99;
    border-radius: 1.5rem;
    overflow: hidden;
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
	}
  button.close {
    position: absolute;
    right: .25rem;
    top: .25rem;
    margin: 0;
    padding: .5rem;
    background: transparent;
    border: none;
    border-radius: 999px;
    cursor: pointer;
  }

  button.close:hover {
      background: #efefef;
  }
  button.close.warning {
    background: rgb(253, 230, 230)
  }
  button.close.warning:hover {
    background: rgb(245, 212, 212)
  }
  button.back {
    position: absolute;
    left: .25rem;
    top: .25rem;
    margin: 0;
    padding: .5rem;
    background: transparent;
    border: none;
    border-radius: 999px;
    cursor: pointer;
  }

  button.back:hover {
      background: #efefef;
  }

  .close svg {
      margin: 0;
      display: block;
  }
</style>